<template>
  <img :src="src" :width="width" :alt="alt" :srcset="set" :style="'aspect-ratio:' + calcWidth + '/' + calcHeight" />
</template>

<script>
import { onMounted, ref } from '@vue/composition-api';
import { getImageDensities } from '@/lego/utils/image/renderer';

export default {
  props: {
    width: {
      type: String,
      required: true,
    },
    src: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const set = ref(null);
    const calcWidth = ref(null);
    const calcHeight = ref(null);

    onMounted(async () => {
      var data = await getImageDensities(props.src, props.width);

      if (data) {
        set.value = data.set;
        calcWidth.value = data.width;
        calcHeight.value = data.height;
      }
    });

    return {
      set,
      calcHeight,
      calcWidth,
    };
  },
};
</script>
